import { useEffect } from 'react';

export default function TidioChat() {
  useEffect(() => {
    if (document.getElementById('tidio-script')) return;
    const tidioKey = import.meta.env.VITE_TIDIO_KEY;
    if (!tidioKey) return;
    const script = document.createElement('script');
    script.src = `//code.tidio.co/${tidioKey}.js`;
    script.async = true;
    script.id = 'tidio-script';
    document.body.appendChild(script);
    // Optionally, cleanup on unmount
    // return () => { document.getElementById('tidio-script')?.remove(); };
  }, []);
  return null;
} 